import { allNav, NavItem } from "./allNav";


export const getNav = (role: string): NavItem[] => {
  return allNav.filter((nav) => nav.role === role);
};
